import { types } from '../../actions'

export default {
    [types.USER_AUTHENTICATED]: [
        {
            event: 'pico.user.authenticated',
            data() {
                return { detail: 'User authenticated' }
            },
        },
    ],
}
